{
  "backLink": "Back to Invoices",
  "pageTitle": "Invoice #{{id}}",
  "detailDate": "Date",
  "detailDatePaid": "Paid date",
  "detailAmount": "Amount",
  "detailStatus": "Status",
  "detailAddress": "Address",
  "detailProvider": "Provider",
  "detailReference": "Reference",
  "detailAccount": "Account",
  "changeStatusButton": "Change Status",
  "downloadPdf": "Download PDF",
  "changeStatusTitle": "Change Status",
  "clickToChange": "Click a status to change it",
  "paidOn": "Paid on {{date}}",
  "sections": {
    "billing": "Billing details",
    "account": "Account",
    "context": "Context",
    "paymentHistory": "Payment attempts",
    "neighbors": "Other invoices"
  },
  "field": {
    "providerAddress": "Provider address",
    "accountKeyword": "Account keyword",
    "username": "Username",
    "createdAt": "First seen",
    "updatedAt": "Last updated",
    "taxDeduction": "Tax deduction",
    "taxDeductionAmount": "Tax deduction amount",
    "skipPayment": "Automatic payment",
    "age": "Invoice age",
    "paymentDuration": "Time to pay",
    "providerAverage": "Provider average",
    "addressAverage": "This address average",
    "password": "Password"
  },
  "enabled": "Enabled",
  "disabled": "Disabled",
  "skipped": "Skipped",
  "daysCount_one": "{{count}} day",
  "daysCount_other": "{{count}} days",
  "outstandingFor": "Outstanding for {{days}}",
  "paidInDays": "Paid in {{days}}",
  "today": "today",
  "aboveProviderAverage": "Above the {{average}} average",
  "belowProviderAverage": "Below the {{average}} average",
  "matchesProviderAverage": "In line with the {{average}} average",
  "copy": "Copy",
  "copied": "Copied",
  "openPdf": "Open PDF",
  "deleteInvoice": "Delete invoice",
  "deleteTitle": "Delete this invoice?",
  "deleteMessage": "Invoice #{{id}} will be removed from all lists. This cannot be undone from here.",
  "previousInvoice": "Previous invoice",
  "nextInvoice": "Next invoice",
  "paymentHistoryEmpty": "No payment attempts have been recorded for this invoice.",
  "attemptRun": "Run #{{id}}",
  "attemptedAt": "Attempted",
  "attemptSource": "Source",
  "resultSuccess": "Paid successfully",
  "resultFailure": "Payment failed",
  "resultPending": "Still processing",
  "sourceLabel": {
    "FE": "Web",
    "MOBILE": "Mobile",
    "DISCORD": "Discord"
  },
  "runStatusLabel": {
    "RUNNING": "Run in progress",
    "COMPLETED": "Run completed",
    "FAILED": "Run failed",
    "CANCELLED": "Run cancelled"
  }
}
